<template>
  <div>
    <div class="table-list mt20">
      <div class="spec-head">
        <div class="sp-col">章节节数</div>
        <div class="sp-col">章节名称</div>
        <div class="sp-col">封面图</div>
        <div class="sp-col">视频课</div>
        <div class="sp-col">视频时长(s)</div>
        <div class="sp-col">操作</div>
      </div>
      <div class="spec-item" v-for="(item, idx) in form.videoData" :key="idx">
        <el-form-item class="sp-col" :prop="`videoData[${idx}].chaptersNum`" label-width="0" :rules="[{required: true,message: '请输入',trigger: 'change'},
        { pattern: /^[0-9]*$/, message: '必须为数字值', trigger: 'blur' }]">
          <el-input v-model="item.chaptersNum" placeholder="请输入" />
        </el-form-item>
        <el-form-item class="sp-col" :prop="`videoData[${idx}].name`" label-width="0" :rules="{required: true,message: '请输入',trigger: 'change',}">
          <el-input v-model="item.name" placeholder="请输入" />
        </el-form-item>
        <el-form-item class="sp-col" :prop="`videoData[${idx}].coverImage`" label-width="0" :rules="{required: !idx?true:false,message: '请上传',trigger: 'change',}">
          <imageUpload v-model="item.coverImage" width="32" height="32" />
        </el-form-item>
        <el-form-item class="sp-col" :prop="`videoData[${idx}].videoUrl`" label-width="0" :rules="{required: true,message: '请上传',trigger: 'change',}">
          <el-input v-if="item.videoUrl.length > 0" v-model="item.videoUrl[0].url" />
          <fileUpload v-model="item.videoUrl" style="opacity: 0" @input="getVideoDuration(item)" v-else />
        </el-form-item>
        <el-form-item class="sp-col" :prop="`videoData[${idx}].duration`" label-width="0" :rules="{required: true,message: '请输入',trigger: 'blur',}">
          <el-input v-model="item.duration" />
        </el-form-item>
        <div class="sp-col oper-icon">
          <i class="el-icon-minus" @click="handleDeleteItem(idx)" v-if="form.videoData.length > 1"></i>
          <i class="el-icon-plus" @click="handleAddItem"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ImageUpload from "@/components/ImageUpload";
import FileUpload from "@/components/FileUpload"
export default {
  props: ['form'],
  components: { ImageUpload, FileUpload },
  data() {
    return {
    }
  },
  created() {
  },
  methods: {
    handleDeleteItem(index) {
      this.form.videoData.splice(index, 1)

    },
    handleAddItem() {
      this.form.videoData.push({ duration: '', chaptersNum: '', name: '', coverImage: '', videoUrl: [], state: 1 })
    },
    getVideoDuration(item) {
      if (item.videoUrl && item.videoUrl.length > 0) {
        var audio = new Audio(item.videoUrl[0].url)
        audio.addEventListener('loadedmetadata', () => {
          //返回的是 秒 格式的时间
          item.duration = parseInt(audio.duration);
          this.$forceUpdate();
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.el-form-item--small.el-form-item.w60 {
  width: 70%;
  display: inline-block;
  vertical-align: top;
  input {
    width: 40%;
  }
}
.el-form-item--small.el-form-item.width100 {
  width: 97%;
}
.flexs {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  .oper {
    width: 300px;
    display: inline-block;
    font-size: 16px;
    span {
      padding-left: 20px;
      cursor: pointer;
    }
    .del {
      color: #e73f3f;
      padding-left: 20px;
    }
    .add {
      color: #5dbde7;
    }
  }
}
.table-list {
  border: 1px solid #e4e4e4;
  // margin: 0 35px 20px 50px;
  .sp-col {
    flex: 1;
    color: #666;
    height: 40px;
    margin-bottom: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-right: 1px solid #e4e4e4;

    &.flex2 {
      // flex-grow: 3;
    }
    ::v-deep .el-form-item__error {
      font-size: 10px;
      right: 0;
      top: 24px;
      text-align: center;
    }

    &:last-child {
      border-right: 0;
    }

    &.enter-param {
      flex: 5;
    }
  }

  .spec-head {
    display: flex;
    font-size: 14px;
    align-items: center;
    background-color: #f9fafc;

    label {
      color: #ff4949;
    }
  }

  .spec-item {
    display: flex;
    font-size: 12px;
    align-items: center;
    border-top: 1px solid #e4e4e4;
    .sp-col {
      .el-input {
        ::v-deep .el-input__inner {
          border: none;
          text-align: center;
        }
      }

      .el-button {
        font-size: 12px;
      }
    }
  }
}
.oper-icon {
  i {
    cursor: pointer;
    font-size: 22px;
    color: #465c99;
    &:nth-child(1) {
      padding-right: 5px;
    }
  }
}
</style>